import type { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { MediaContainer } from '../../post/components';
import { Block, OuterBlock, RegularBlock } from './Block';
import { Columns } from './Columns';
import { hasColor, padding, space } from './helpers';
import { RepostPreviewBlock } from './RepostPreviewBlock';

const getBorderRadius = (borderRadius?: number | string) => {
  if (typeof borderRadius === 'string') {
    return borderRadius;
  }

  return `${borderRadius ?? 8}px`;
};

export const PreviewLinkBlock = styled(OuterBlock)``;

export const HorizontalCardContentContainer = styled.div`
  &:not(:only-child) {
    max-width: 50%;
  }
`;

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  _overlay?: boolean;
  _shadow?: string;
  _space?: number;
  _borderRadius?: number | string;
  _backgroundColor?: string;
  _minHeight?: number;
  _heightNormalization?: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  outline: none;
  overflow: hidden;
  height: ${({ _heightNormalization }) =>
    _heightNormalization ? '100%' : 'auto'};
  border-radius: ${({ _borderRadius }) => getBorderRadius(_borderRadius)};

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  ${({ _minHeight }) =>
    _minHeight &&
    css`
      min-height: ${_minHeight}px;

      & ${MediaContainer} img {
        min-height: ${_minHeight}px;
      }
    `}

  ${({ _backgroundColor, _shadow, _space, _borderRadius }) =>
    hasColor(_backgroundColor)
      ? css`
          background: ${_backgroundColor};
          box-shadow: ${_shadow || 'none'};

          & ${RegularBlock}, & ${PreviewLinkBlock}, & ${RepostPreviewBlock} {
            padding: 0 ${padding(_space)}px;
          }
          &
            ${RegularBlock}:first-child,
            &
            ${PreviewLinkBlock}:first-child,
            &
            ${RepostPreviewBlock}:first-child {
            padding-top: ${padding(_space)}px;
          }
          &
            ${RegularBlock}:last-child,
            &
            ${PreviewLinkBlock}:last-child,
            &
            ${RepostPreviewBlock}:last-child {
            padding-bottom: ${padding(_space)}px;
          }
        `
      : css`
          overflow: visible;

          & ${Block} {
            overflow: hidden;
          }

          & ${OuterBlock} {
            box-shadow: ${_shadow || 'none'};
            border-radius: ${getBorderRadius(_borderRadius)};
          }
          & ${Columns} > div:not(:first-child) {
            margin-left: ${padding(_space)}px;
          }
        `}

  ${({ _overlay, _space, _backgroundColor, _shadow }) =>
    !hasColor(_backgroundColor) &&
    _overlay &&
    css`
      overflow: hidden;
      box-shadow: ${_shadow || 'none'};

      & ${Columns} > div:not(:first-child) {
        margin-left: ${padding(_space)}px;
      }
    `}

  & ${Block}:not(:first-child) {
    margin-top: ${({ _space }) => space(_space)}px;
  }

  & ${Block}:only-child {
    flex: 1;
    max-height: 100%;
    max-width: 100%;
  }

  & ${OuterBlock} + ${OuterBlock} {
    margin-top: 0;
  }

  & ${Columns} ${OuterBlock} {
    margin-top: 0;
  }

  & ${Columns} ${PreviewLinkBlock}, & ${OuterBlock} + ${PreviewLinkBlock} {
    margin-top: ${({ _space }) => space(_space)}px;
  }
`;
